import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

interface CreateFamilyAlbumApiCallParams {
    album_id: string;
}

export class CreateFamilyAlbumApiCall extends APICallV4<CreateFamilyAlbumApiCallParams | null> {
    _method = 'family/album/share';
    _type: Method = 'post';
    _retriesCount = 0;
}
